import CustomStore from "devextreme/data/custom_store";
import { apiConfiguration } from "../apiConfig";
import { OrdiniApi } from "../data/apis/OrdiniApi";
import { ProdottoDTO } from "../data/models";

export function prodottiDataSource(idOrdine: number) {
 return new CustomStore({
    key: "codice",
    loadMode : 'raw',
    
    
    load: (loadOptions) => {
      const api = new OrdiniApi(apiConfiguration);     
      return api.getProdottiByOrdine({
        idOrdine:idOrdine
    });
        
    }

});
}
